import { ChangeDetectorRef, Component, EventEmitter, OnInit, Output } from '@angular/core';
import {Observable, Subscription} from 'rxjs';
import {ActivatedRoute, Router} from '@angular/router';
import { DossierIntervention } from 'app/models/dossier_intervention.model';
import {AbstractControl, FormGroup} from '@angular/forms';
import { DossierInterventionService } from 'app/services/dossier_intervention.service';
import { UserService } from 'app/services/user.service';
import { UserService as CoreUserService } from 'app/core/user/user.service';
import { User } from 'app/models/user.model';
import { User as CoreUser } from 'app/core/user/user.types';
import {get} from 'lodash-es';
import {FicheIntervention} from '../../../models/ficheIntervention.model';
import {FicheInterventionService} from '../../../services/fiche-intervention.service';
import {MatDialog, MatDialogRef} from '@angular/material/dialog';
import {ModalEquipementV2Component} from './equipement/modal-equipement-v2.component';
import {PieceEquipement} from '../../../models/pieceEquipement.model';
import {NomPiece} from '../../../models/nomPiece.model';
import {EquipementService} from '../../../services/equipement.service';
import {Piece} from '../../../models/piece.model';
import {ModalPieceComponent} from './piece/modal-piece.component';
import {PieceService} from '../../../services/piece.service';
import { Niveau } from 'app/models/niveau.model';
import {Etage} from "../../../models/etage.model";
import {EtageService} from "../../../services/etage.service";
import {NiveauService} from "../../../services/niveau.service";

@Component({
  selector: 'app-dossier-intervention-v2',
  templateUrl: './dossier-intervention-v2.component.html'
})
export class DossierInterventionV2Component implements OnInit {
    @Output() valueChanged = new EventEmitter();

    idDossierIntervention: number;
    currentFicheIntervention: FicheIntervention;
    currentDossierIntervention: DossierIntervention = new DossierIntervention();
    errors: string[] = [];
    success: boolean = false;
    error: boolean = false;
    users: User[] = [];
    tabIndex: number = 0;
    user: CoreUser;
    unsavedChanges: boolean = false;

    piecesEquipements: PieceEquipement[] = [];
    nomsPieces: NomPiece[] = [];

    pieces: Piece[] = [];
    etages: Etage[] = [];
    niveaux: Niveau[] = [];

    dossierInterventionForm: FormGroup;

    private routeSub: Subscription;
    private isDossierLoaded: boolean = false;
    private isFicheLoaded: boolean = false;
    private isPiecesLoaded: boolean = false;
    private isNomPiecesLoaded: boolean = false;
    private isPiecesEquipementsLoaded: boolean = false;

    constructor(

        private dossierInterventionService: DossierInterventionService,
        private ficheInterventionService: FicheInterventionService,
        private userService: UserService,
        private etageService: EtageService,
        private niveauService: NiveauService,
        private cd: ChangeDetectorRef,
        private route: ActivatedRoute,
        private router: Router,
        private _userService: CoreUserService,
        private dialog: MatDialog,
        private equipementService: EquipementService,
        private pieceService: PieceService
        ) { }

    get f(): { [p: string]: AbstractControl } | undefined
    {
        return this.dossierInterventionForm?.controls;
    }

    get isLoaded(): boolean{
        return this.isDossierLoaded && this.isFicheLoaded && this.isPiecesLoaded && this.isNomPiecesLoaded && this.isPiecesEquipementsLoaded;
    }
    ngOnInit(): void {
        this._userService.user$
            .subscribe((user: CoreUser) => {
                this.user = user;
            });

        this.route.params.subscribe((params) => {
            this.idDossierIntervention = params['idDossierIntervention'];
            this.getDossierIntervention(this.idDossierIntervention);
        });

        this.tabIndex = get(this.route, 'snapshot.fragment', 0);

        this.getUsers();
        this.getPiecesEquipementsLaisse();
        this.getEtages();
        this.fetchPieces();
        const usersId = [];
        if(this.currentDossierIntervention.users !== undefined && this.currentDossierIntervention.users.length > 0){
            for(const user of this.currentDossierIntervention.users){
                usersId.push(user.id);
            }
        }
    }
    getEtages() {
        this.etageService.getEtages(this.idDossierIntervention).subscribe((etages) => {
            this.etages = etages;

            this.getNiveaux();
        });
    }

    getNiveaux() {
        this.niveauService.getNiveaux().subscribe((niveaux) => {
            this.niveaux = niveaux;
        });
    }

    getDossierIntervention(id: number): void{
        this.dossierInterventionService.getDossierIntervention(id).subscribe((dossierIntervention) => {
            this.currentDossierIntervention = dossierIntervention;
            this.isDossierLoaded = true;
        });

        this.ficheInterventionService.getFichesInterventions(id).subscribe((ficheInterventions) => {
            this.currentFicheIntervention = ficheInterventions.pop() ?? new FicheIntervention();
            this.isFicheLoaded = true;
        });
    }

    fetchPieces(): void{
        this.pieceService.getPieces(this.idDossierIntervention).subscribe((pieces) => {
            this.pieces = pieces;
            this.isPiecesLoaded = true;
        });
    }

    getUsers(): void {
        this.userService.getUsers().subscribe((users) => {
            this.users = users;
        });
    }

    onFormSubmit(): void{
        this.error = false;
        this.success = false;
        this.dossierInterventionForm.markAllAsTouched();

        if(this.dossierInterventionForm.valid){
            const dossierIntervention = new DossierIntervention(this.dossierInterventionForm.value);
            this.dossierInterventionService.update(dossierIntervention, this.currentDossierIntervention.id).subscribe(
                (response) => {
                    this.routeSub = this.route.params.subscribe((params) => {
                        if(params['id'] != null){
                            this.router.navigate(
                                ['/dossiersInterventions'],
                                { relativeTo: this.route, queryParams: { } }
                            );
                        }
                    });
                    this.success = true;
                    this.unsavedChanges = false;
                },(error) => {
                    this.error = true;
                }
            );
        }
    }

    /**
     * Track by function for ngFor loops
     *
     * @param index
     * @param item
     */
    trackByFn(index: number, item: any): any
    {
        return item.id || index;
    }

    onValueChanged(hasChanged) {
        this.valueChanged.emit(hasChanged);
    }

    openEquipementModal(piece: Piece): MatDialogRef<ModalEquipementV2Component> {
        const dialogRef = this.dialog.open(ModalEquipementV2Component, {
            width: '75%',
        });

        dialogRef.componentInstance.idDossierIntervention = this.currentDossierIntervention.id;

        dialogRef.afterClosed().subscribe((result) => {
            this.getPiecesEquipementsLaisse();
        });

        return dialogRef;
    }

    openPieceModal(piece: Piece = null, niveau: Niveau = null): MatDialogRef<ModalPieceComponent> {
        const dialogRef = this.dialog.open(ModalPieceComponent, {
            width: '75%',
        });

        if (piece == null) {
            piece = new Piece();
        }

        if (niveau == null) {
            niveau = new Niveau();
        }

        dialogRef.componentInstance.idDossierIntervention = this.currentDossierIntervention.id;

        dialogRef.componentInstance.pieces = this.pieces;
        dialogRef.componentInstance.piece = piece;
        dialogRef.componentInstance.niveau = niveau;

        dialogRef.afterClosed().subscribe((result) => {
            this.fetchPieces();
        });

        return dialogRef;
    }

    getPiecesEquipementsLaisse(): void {
        this.equipementService.getPieceEquipementsLaissesParIdDossierIntervention(this.idDossierIntervention).subscribe((result) => {
            this.piecesEquipements = result.piecesEquipements;
            this.nomsPieces = result.nomsPieces;
            this.isNomPiecesLoaded = true;
            this.isPiecesEquipementsLoaded = true;
        });
    }

}
